import React, { createContext, useState, useEffect } from 'react';
import axios from 'axios'
import UsuarioService from '../service/usuario.service';
import config from '../environments/config';
var pointInPolygon = require('point-in-polygon');

const usuarioService = new UsuarioService();
const UserContext = createContext({});
let bUsuarioAlertadoPagamentoPendente = false;

export const UserProvider = ({ children }) => {
    const [user, setUser] = useState(localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : null);
    // const [manterConectado, setManterConectado] = useState(false);
    const [loading, setLoading] = useState(false);
    const [modal, setModal] = useState(null);
    const [produtoSelecionado, setProduto] = useState(null);
    const [categoria, setCategoria] = useState(null);
    const [paginaAtual, setPaginaAtual] = useState(1);
    const [filtro, setFiltro] = useState(null);
    const [credito, setCredito] = useState(null);
    const [carrinho, setCarrinho] = useState([]);
    // const [carrinho, setCarrinho] = useState(JSON.parse('[{"Status":true,"Key":"-MhOiNXyxrXNMqYim_5V","CodigoBarras":"","CodigoProduto":206,"Comissao":"","DescricaoComplementar":"Composto Lac Piracamjuba Otimo 400gr com 1 Unidade","Grupo":"Leites","IDGrupo":"-MhOiK9Aiw3l9maopiJP","IDUnidade":"-Ma3PLw8dqjlO5OBjA1g","Identificador":"","Nome":"Composto Lac Piracamjuba Otimo 400gr c/1","NomeBusca":"composto lac piracamjuba otimo 400gr c/1","QuantidadeEstoque":2,"QuantidadeAtacado":"","QuantidadeMinima":1,"QuantidadeMaxima":3,"Referencia":"","TimestampFinalPromocional":1629297791056,"TimestampInicialPromocional":1629297791056,"TipoItem":"Venda","URL_Imagem":"https://firebasestorage.googleapis.com/v0/b/ipanemadistribuidoraproducao.appspot.com/o/IpanemaImagens%2F1629297937482?alt=media&token=2a160251-7a8e-4366-bc72-e78acaff974d","Unidade":"UN","Valor":7.9,"ValorString":"7,90","ValorAtacado":0,"ValorPromocional":0,"ValorReal":"7","ValorCentavos":"90","QuantidadeComprada":2,"IDGrupoPromocional":"","NomeGrupoPromocional":"","PorcentagemDesconto":false,"ValorRealDesconto":"","ValorCentavosDesconto":"","ValorDesconto":0,"DescontoGrupoPromocional":false},{"Status":true,"Key":"-MhOhBMNEsP6OpQJohtc","CodigoBarras":"","CodigoProduto":205,"Comissao":"","DescricaoComplementar":"Leite Condensado 270Gr Piracanjuba com 1 Unidade","Grupo":"Balas e Doces","IDGrupo":"-Ma3h2WFEzg8AOly_qkY","IDUnidade":"-Ma3PLw8dqjlO5OBjA1g","Identificador":"","Nome":"Leite Condensado 270Gr Piracanjuba C/1","NomeBusca":"leite condensado 270gr piracanjuba c/1","QuantidadeEstoque":32,"QuantidadeAtacado":"","QuantidadeMinima":1,"QuantidadeMaxima":999,"Referencia":"","TimestampFinalPromocional":1629297554963,"TimestampInicialPromocional":1629297554963,"TipoItem":"Venda","URL_Imagem":"https://firebasestorage.googleapis.com/v0/b/ipanemadistribuidoraproducao.appspot.com/o/IpanemaImagens%2F1629297624980?alt=media&token=8cc3dac7-d044-410e-b4e0-99abdb094807","Unidade":"UN","Valor":3.5,"ValorString":"3,50","ValorAtacado":0,"ValorPromocional":0,"ValorReal":"3","ValorCentavos":"50","QuantidadeComprada":5,"IDGrupoPromocional":"","NomeGrupoPromocional":"","PorcentagemDesconto":false,"ValorRealDesconto":"","ValorCentavosDesconto":"","ValorDesconto":0,"DescontoGrupoPromocional":false}]'));
    const [itensRemovidosFaltaEstoqueCarrinho, setItensRemovidosFaltaEstoqueCarrinho] = useState([]);
    const [idCompraConfirmadaEstoqueAlterado, setIDCompraConfirmadaEstoqueAlterado] = useState(null);
    const [bPentendeCompraAlteradaEstoque, setBPentendeCompraAlteradaEstoque] = useState(false);

    const [totalCompra, setTotalCompra] = useState(0);
    const [contItens, setContItens] = useState(0);
    const [pedidoSelecionado, setPedidoSelecionado] = useState(null);
    const [produtosPedidoSelecionadoViaURL, setprodutosPedidoSelecionadoViaURL] = useState(null);
    const [valorMinimoBoleto, setValorMinimoBoleto] = useState(100);
    const [valorMinimoBoletoQuinzeDias, setValorMinimoBoletoQuinzeDias] = useState(1000);
    const [valorMinimoDuasParcelas, setValorMinimoDuasParcelas] = useState(1000);
    const [valorMinimoPedido, setValorMinimoPedido] = useState(0);
    const [valorMinimoCheque, setValorMinimoCheque] = useState(1000);
    //Grupos promocionais
    const [gruposPromocionais, setGruposPromocionais] = useState([]);
    const [listaProdutosPromocionais, setListaProdutosPromocionais] = useState([]);
    const [grupoPromocionalProdutoSelecionado, setGrupoPromocionalProdutoSelecionado] = useState(null);
    const [contTotalProdutosGrupo, setContTotalProdutosGrupo] = useState(0);

    //Status servidor
    const [statusVersaoServidor, setStatusVersaoServidor] = useState(null);
    const [statusServidor, setStatusServidor] = useState(true);

    //Dados Rota
    const [latitude, setLatitude] = useState(false);
    const [longitude, setLongitude] = useState(false);
    const [aDatasDisponiveisRota, setADatasDisponiveisRota] = useState([]);
    const [sDiaRotaPrevisaoRota, setSDiaRotaPrevisaoRota] = useState(false);
    const [timestampPrevisaoRota, setTimestampPrevisaoRota] = useState(false);
    const [idCidade, setIDCidade] = useState(false);
    const [idRotaEntrega, setIDRotaEntrega] = useState(false);
    const [nomeRota, setNomeRota] = useState(false);

    //Controle de atualização estoque produtos
    const [bAtualizarProdutosHome, setBAtualizarProdutosHome] = useState(false);

    //Ip
    const [ip, setIP] = useState('ip_não_identificado');

    //Bloqueia compra com pagamento pendente
    const [bloquearCompraPagamentoPendente, setBloquearCompraPagamentoPendente] = useState(true);
    const [pagamentoPendente, setPagamentoPendente] = useState(false);

    //Credito Voucher
    const [creditoVoucher, setCreditoVoucher] = useState(0);
    const [mensagemPagamentoPendente, setMensagemPagamentoPendente] = useState('');


    useEffect(() => {
        setTimeout(() => calcularTotalCompra(carrinho), 100); // Remover
        getIP();

        if (!localStorage.getItem('manterConectado') === 'true') {
            SingOut();
        }
        if (!localStorage.getItem('manterConectado') === 'true') {
            getStatusCliente(user.user.uid)
        }

        if (user) {
            getCredito(user.user);
            getValoresMinimos();
            getGruposPromocionais(user.user);
            getVerificarRota(user.user.uid);
            getBloquearCompraPagamentoPendente(user.user.uid);
            verificaPagamentoPendente(user.user.uid);
            getCreditoVoucher(user.user.uid);
        }
        getStatusServidor();
    }, []);

    function getStatusCliente(uid) {
        setTimestampPlataforma(uid);
        const statusCliente = usuarioService.getStatusCliente(uid).on('value', snapshot => {
            if (!snapshot.val()) {
                alert('Seu usuário não está permitido para utilizar o sistema!');
                SingOut();
            } else {
                const auxCarrinho = localStorage.getItem('carrinho') ? JSON.parse(localStorage.getItem('carrinho')) : [];
                if (auxCarrinho.length > 0) {
                    setCarrinho(auxCarrinho);
                    setContItens(auxCarrinho.length);
                    calcularTotalCompra(auxCarrinho);
                }
            }
        });
    }

    async function getIP() {
        const res = await axios.get('https://geolocation-db.com/json/')
        setIP(res.data.IPv4)
    }

    function setTimestampPlataforma(uid) {
        const resp = usuarioService.setTimestampPlataforma(uid);
    }

    function getStatusServidor() {
        const response = usuarioService.getStatusLoja().on('value', snapshot => {
            const dados = snapshot.val();

            if (!dados.Status) {
                setStatusVersaoServidor({
                    descricao: dados.Descricao, previsaoRetorno: dados.PrevisaoRetorno
                });
                setStatusServidor(false);
                setModal('Manutencao');
            } else
                if (config.versao < dados.VersaoMinima) {
                    setStatusServidor(false);
                    setModal('VersaoSistema');
                }
        });
    }

    async function RecuperarSenha(email) {
        const response = await usuarioService.recuperarSenha(email);
        return response;
    }


    async function Login(email, password, bConectado) {
        const response = await usuarioService.login(email, password);
        if (response) {
            const statusCliente = usuarioService.getStatusCliente(response.user.uid).on('value', snapshot => {
                if (snapshot.val()) {
                    setUser(response);
                    localStorage.setItem('user', JSON.stringify(response));
                    bConectado ? localStorage.setItem('manterConectado', 'true') : localStorage.removeItem('manterConectado');
                    setTimeout(() => getCredito(response.user), 500);
                    setTimeout(() => getGruposPromocionais(response.user), 500);
                    setTimeout(() => getVerificarRota(response.user.uid), 500);
                } else {
                    alert('Seu usuário não está permitido para utilizar o sistema!');
                    SingOut();
                }
            });

        } else {
            localStorage.removeItem('user');
            localStorage.removeItem('manterConectado');
        }
    }

    async function SingOut() {
        const response = await usuarioService.singOut();
        setUser(null);
        localStorage.removeItem('user');
        localStorage.removeItem('manterConectado');
        localStorage.removeItem('carrinho');
        usuarioService.singOut();
    }

    async function getCredito(user) {
        usuarioService.getCredito(user.uid).on('value', snapshot => {
            setCredito(snapshot.val());
        });
    }

    async function getCreditoVoucher(idUsuario) {
        usuarioService.getCreditoVoucher(idUsuario).on('value', snapshot => {
            setCreditoVoucher(snapshot.val() ? snapshot.val() : 0);
        });
    }

    function updateLoading() {
        setLoading(!loading);
    }

    function updateModal(value) {
        setModal(value);
    }

    async function setSolicitacaoCadastro(map) {
        const response = await usuarioService.setSolicitacaoCadastro(map);
        return response;
    }

    //Recupera os grupos promocionais para poder validar se estão ativos e comparar com os do usuário
    async function getGruposPromocionais(user) {
        const response = usuarioService.getGruposPromocionaisUsuario(user.uid).on('value', snapshot => {

            let dados;
            let auxGruposUsuario = [];

            snapshot.forEach((item) => {
                dados = item.val();

                auxGruposUsuario.push({
                    IDGrupoDesconto: dados.IDGrupoDesconto,
                    PorcentagemDesconto: dados.PorcentagemDesconto,
                    Nome: dados.Nome,
                    Produtos: dados.Produtos,
                    ProdutosString: dados.ProdutosString,
                    QuantidadeMinima: dados.QuantidadeMinima,
                    Status: false
                })
            });

            //Validar Status dos grupos
            const response2 = usuarioService.getGruposTodosPromocionaisVendedor(user.uid).on('value', snapshot => {

                const todosGruposPromocionaisVendedor = snapshot.val();
                for (let i = 0; i < auxGruposUsuario.length; i++) {
                    for (var key in todosGruposPromocionaisVendedor) {
                        if (auxGruposUsuario[i].IDGrupoDesconto === key) {
                            auxGruposUsuario[i].Status = todosGruposPromocionaisVendedor[key].Status;
                        }
                    }
                }

                setGruposPromocionais(auxGruposUsuario);

                //Cria a lista com produtos ativos em promoções
                let auxProdutosPromocionais = [];
                for (let i = 0; i < auxGruposUsuario.length; i++) {
                    if (auxGruposUsuario[i].Status) {
                        for (let j = 0; j < auxGruposUsuario[i].Produtos.length; j++) {
                            auxProdutosPromocionais.push({ NomeGrupoPromocional: auxGruposUsuario[i].Nome, IDProduto: auxGruposUsuario[i].Produtos[j].ID, IDGrupo: auxGruposUsuario[i].IDGrupoDesconto, QuantidadeMinima: auxGruposUsuario[i].QuantidadeMinima, PorcentagemDesconto: auxGruposUsuario[i].PorcentagemDesconto });
                        }
                    }
                }

                setListaProdutosPromocionais(auxProdutosPromocionais);
            });
        });
    }

    function validarDescontoGrupoProduto(produto, carrinho) {
        const auxGrupoProduto = listaProdutosPromocionais[listaProdutosPromocionais.findIndex(x => x.IDProduto === produto.Key)];

        let cont = 0;
        const index = auxGrupoProduto ? gruposPromocionais.findIndex(x => x.IDGrupoDesconto === auxGrupoProduto.IDGrupo) : -1;
        if (index !== -1) {
            if (carrinho.length > 0) {

                for (let i = 0; i < carrinho.length; i++) {
                    if (gruposPromocionais[index].Produtos.findIndex(x => x.ID === carrinho[i].Key) !== -1) {
                        cont += gruposPromocionais[index].Produtos.findIndex(x => x.ID === carrinho[i].Key) !== -1 ? (carrinho[i].QuantidadeComprada) : 0;
                    }
                }
            } else
                cont += produto.QuantidadeComprada; //Se o carrinho não estiver inicializado ou for o produto, colocar a quantidade comprada no cont.
        }

        if (auxGrupoProduto && cont >= auxGrupoProduto.QuantidadeMinima) {
            return auxGrupoProduto.PorcentagemDesconto;
        } else
            return false
    }

    function getGrupoPromocionalProduto(produto) {
        const auxGrupoProduto = listaProdutosPromocionais[listaProdutosPromocionais.findIndex(x => x.IDProduto === produto.Key)];
        return auxGrupoProduto !== -1 ? auxGrupoProduto : false;
    }

    //Remover está função e utilizar a de cima
    function contarProdutosGrupo(idGrupo) {
        let cont = 0;

        let aux;
        const index = gruposPromocionais.findIndex(x => x.IDGrupoDesconto === idGrupo);
        if (index !== -1) {
            for (let i = 0; i < carrinho.length; i++) {
                aux = gruposPromocionais[index].Produtos.findIndex(x => x.ID === carrinho[i].Key) !== -1 ? (cont += carrinho[i].QuantidadeComprada) : null;
            }
        }

        setContTotalProdutosGrupo(cont);
    }

    function selecionarProduto(produto) {
        setProduto(produto)
        //Valida se o produto está em um grupo promocional
        const auxProduto = JSON.parse(produto);
        const auxGrupoProduto = listaProdutosPromocionais[listaProdutosPromocionais.findIndex(x => x.IDProduto === auxProduto.Key)];

        if (auxGrupoProduto) {
            setGrupoPromocionalProdutoSelecionado(gruposPromocionais[gruposPromocionais.findIndex(x => x.IDGrupoDesconto === auxGrupoProduto.IDGrupo)]);
            contarProdutosGrupo(auxGrupoProduto.IDGrupo);
        } else
            setGrupoPromocionalProdutoSelecionado(null);
    }

    function updateCategoria(value) {
        setCategoria(value)
    }

    function updatePaginaAtual(value) {
        setPaginaAtual(value)
    }

    function updateFiltro(value) {
        setFiltro(value)
    }

    function updateCredito(value) {
        setCredito(value);
    }

    function verficaProdutoCarrinho(value) {
        const index = carrinho.findIndex(x => x.Key === value.Key);
        return index !== -1 ? carrinho[index].QuantidadeComprada : false;
    }

    function updateItemCarrinho(produto, quantidade) {
        let auxProdutos = carrinho;
        const indexProdutoNoCarrinho = carrinho.findIndex(x => x.Key === produto.Key);
        let aux = {
            Key: produto.Key,
            CodigoBarras: produto.CodigoBarras,
            CodigoProduto: produto.CodigoProduto,
            Comissao: produto.Comissao,
            LucroBruto: produto.LucroBruto,
            CustoCompra: produto.CustoCompra,
            DescricaoComplementar: produto.DescricaoComplementar,
            Grupo: produto.Grupo,
            IDGrupo: produto.IDGrupo,
            IDUnidade: produto.IDUnidade,
            Identificador: produto.Identificador,
            Nome: produto.Nome,
            NomeBusca: produto.NomeBusca,
            // Quantidade: quantidade,
            QuantidadeEstoque: produto.QuantidadeEstoque,
            QuantidadeAtacado: produto.QuantidadeAtacado,
            QuantidadeMinima: produto.QuantidadeMinima,
            QuantidadeMaxima: produto.QuantidadeMaxima,
            Referencia: produto.Referencia,
            TimestampFinalPromocional: produto.TimestampFinalPromocional,
            TimestampInicialPromocional: produto.TimestampInicialPromocional,
            TipoItem: produto.TipoItem,
            URL_Imagem: produto.URL_Imagem,
            Unidade: produto.Unidade,
            Valor: produto.Valor,
            ValorString: produto.ValorString,
            ValorAtacado: produto.ValorAtacado ? produto.ValorAtacado : 0,
            ValorPromocional: produto.ValorPromocional,
            ValorReal: produto.ValorReal,
            ValorCentavos: produto.ValorCentavos,
            //Parametros adicionais
            QuantidadeComprada: Number(quantidade),
            IDGrupoPromocional: '',
            NomeGrupoPromocional: '',
            PorcentagemDesconto: false,
            ValorRealDesconto: '',
            ValorCentavosDesconto: '',
            ValorDesconto: 0,
            DescontoGrupoPromocional: false,
        }
        if (indexProdutoNoCarrinho !== -1) {
            auxProdutos[indexProdutoNoCarrinho] = aux;
        } else {
            auxProdutos.push(aux);
            setContItens(contItens + 1);
        }
        setCarrinho(auxProdutos);
        localStorage.setItem('carrinho', JSON.stringify(auxProdutos));
        calcularTotalCompra(auxProdutos);
    }

    function calcularTotalCompra(carrinho) {
        let descontoPromocional;
        let valorUnitarioComDesconto;
        let auxTotal = 0;

        for (let i = 0; i < carrinho.length; i++) {
            descontoPromocional = validarDescontoGrupoProduto(carrinho[i], carrinho);

            if (!descontoPromocional) {
                auxTotal += (carrinho[i].Valor * carrinho[i].QuantidadeComprada)
            } else {
                valorUnitarioComDesconto = (carrinho[i].Valor - (carrinho[i].Valor * (0.01 * descontoPromocional))).toFixed(2);
                auxTotal += (valorUnitarioComDesconto * carrinho[i].QuantidadeComprada);
            }
        }
        setTotalCompra(auxTotal);
    }

    function removerItemCarrinho(value) {
        let auxProdutos = carrinho;
        const index = carrinho.findIndex(x => x.Key === value.Key);

        if (index !== -1) {
            const aux = auxProdutos.filter(item => item !== value);

            setCarrinho(aux);
            calcularTotalCompra(aux);
            setContItens(contItens - 1);
            localStorage.setItem('carrinho', JSON.stringify(aux));
        }
    }

    function esvaziarCarrinho() {
        setContItens(0);
        setTotalCompra(0);
        setCarrinho([]);
        setItensRemovidosFaltaEstoqueCarrinho([]);
        localStorage.removeItem('carrinho');
    }

    function selecionarPedido(value) {
        setPedidoSelecionado(value)
    }

    function setProdutosPedidoSelecionadoURL(value) {
        setprodutosPedidoSelecionadoViaURL(value)
    }

    async function limparCarrinhoCompraEstoque() {
        setBPentendeCompraAlteradaEstoque(false);
        esvaziarCarrinho();
        //Envia como array pois a função é utilizada pelo admin
        const response = await usuarioService.estornarProdutosEstoqueCompraCancelada([idCompraConfirmadaEstoqueAlterado]);
    }

    async function getValoresMinimos() {
        const response = await usuarioService.getValoresMinimos().once('value', snapshot => {
            if (snapshot) {
                const dados = snapshot.val();
                setValorMinimoBoleto(dados.Boleto);
                setValorMinimoPedido(dados.Pedido);
                setValorMinimoBoletoQuinzeDias(dados.BoletoQuinzeDias);
                setValorMinimoDuasParcelas(dados.BoletoDuasParcelas);
                setValorMinimoCheque(dados.Cheque);
            }
        });
    }

    async function getVerificarRota(uid) {
        const response = await usuarioService.getEndereco(uid).once('value', async snapshot => {
            if (snapshot) {
                const dados = snapshot.val();

                let latitude = dados.Latitude;
                let longitude = dados.Longitude;
                setLatitude(latitude);
                setLongitude(longitude)

                if (latitude && longitude) {
                    const responseCidades = await usuarioService.getCidades(dados.UF, dados.Cidade).once('value', async snapCidade => {
                        if (snapCidade) {
                            const dados = snapCidade.val();

                            let auxDados;
                            let auxIDCidade;
                            snapCidade.forEach((item) => {
                                auxDados = item.val();
                                if (auxDados.Status) {
                                    auxIDCidade = item.key;
                                    setIDCidade(item.key);
                                }
                            });

                            if (auxIDCidade) {
                                const responseRotas = await usuarioService.getRotas(auxIDCidade).once('value', snapRota => {
                                    if (snapRota) {
                                        const dadosRota = snapRota.val();
                                        if (dadosRota) {
                                            Object.keys(dadosRota).forEach((key, index) => {
                                                const detalhesRota = dadosRota[key];

                                                let polygon = [];

                                                const auxPolygon = JSON.parse(detalhesRota.Area);
                                                Object.keys(auxPolygon).forEach((keyPolygon, index) => {
                                                    polygon.push([auxPolygon[keyPolygon].lat, auxPolygon[keyPolygon].lng]);
                                                });

                                                if (pointInPolygon([latitude, longitude], polygon)) {
                                                    setIDRotaEntrega(key);
                                                    verificarProximaDataRota(JSON.parse(detalhesRota.Datas), key);
                                                    setNomeRota(detalhesRota.Nome);
                                                }
                                            });
                                        }
                                    }
                                });
                            }
                        }
                    });
                }
            }
        });
    }

    function verificarProximaDataRota(datasRota, keyRotaCidade) {
        let diaAtual = new Date(); //Data atual;
        diaAtual.setHours(22);
        diaAtual.setMinutes(59);
        diaAtual.setSeconds(59);
        diaAtual.setMilliseconds(999);

        let auxDate = new Date();

        let proximoDiaSemana = false;

        let auxArrayDatas = [];

        const auxDate2 = new Date();
        //Armazenar as próximas datas disponíveis para entrega. O próximo loop faz um "break" quando encontra a próxima data disponível.
        for (let j = 0; j < datasRota.length; j++) {
            auxDate = new Date(datasRota[j]);
            auxDate.setHours(21);
            auxDate.setMinutes(59);
            auxDate.setSeconds(59);
            auxDate.setMilliseconds(999);

            //Pedidos mesmo dia antes das 13hrs
            //-Mm_uVCJuGn_BxwUZyi0 NV Horizonte
            //-Mm_uWHk9jm7XpSXm0Hm Vilela
            //-Mn0R0UgKkdUCgcZ52lS Nove de Março
            //-Mn0TNo-MEZGvPFbxpQ1 Centro e mercado
            //-Mn0Tib_qGfk2MJX_pxz Centro e mercado
            // if ((keyRotaCidade === '-Mm_uVCJuGn_BxwUZyi0' || keyRotaCidade === '-Mm_uWHk9jm7XpSXm0Hm' || keyRotaCidade === '-Mn0R0UgKkdUCgcZ52lS' || keyRotaCidade === '-Mn0U0W-afusaLFo386y') && new Date().getHours() < 22) { //TESTE
            if ((keyRotaCidade === '-Mm_uVCJuGn_BxwUZyi0' || keyRotaCidade === '-Mm_uWHk9jm7XpSXm0Hm' || keyRotaCidade === '-Mn0R0UgKkdUCgcZ52lS' || keyRotaCidade === '-Mn0TNo-MEZGvPFbxpQ1' || keyRotaCidade === '-Mn0Tib_qGfk2MJX_pxz') && auxDate2.getHours() < 13) { //Produção
                if (auxDate.getTime() >= diaAtual.getTime()) {
                    //Salvar as datas disponíveis
                    auxArrayDatas.push(auxDate);
                }
            } else
                if (auxDate.getTime() > diaAtual.getTime()) {
                    //Salvar as datas disponíveis
                    auxArrayDatas.push(auxDate);
                }
        }

        setADatasDisponiveisRota(auxArrayDatas);

        for (let i = 0; i < datasRota.length; i++) {
            auxDate = new Date(datasRota[i]);
            auxDate.setHours(21);
            auxDate.setMinutes(59);
            auxDate.setSeconds(59);
            auxDate.setMilliseconds(999);

            //Pedidos mesmo dia antes das 13hrs
            //-Mm_uVCJuGn_BxwUZyi0 NV Horizonte
            //-Mm_uWHk9jm7XpSXm0Hm Vilela
            //-Mn0R0UgKkdUCgcZ52lS Nove de Março
            //-Mn0TNo-MEZGvPFbxpQ1 Centro e mercado
            //-Mn0Tib_qGfk2MJX_pxz Centro e mercado
            // if ((keyRotaCidade === '-Mm_uVCJuGn_BxwUZyi0' || keyRotaCidade === '-Mm_uWHk9jm7XpSXm0Hm' || keyRotaCidade === '-Mn0R0UgKkdUCgcZ52lS' || keyRotaCidade === '-Mn0U0W-afusaLFo386y') && new Date().getHours() < 22) { //TESTE
            if ((keyRotaCidade === '-Mm_uVCJuGn_BxwUZyi0' || keyRotaCidade === '-Mm_uWHk9jm7XpSXm0Hm' || keyRotaCidade === '-Mn0R0UgKkdUCgcZ52lS' || keyRotaCidade === '-Mn0TNo-MEZGvPFbxpQ1' || keyRotaCidade === '-Mn0Tib_qGfk2MJX_pxz') && auxDate2.getHours() < 13) { //Produção
                if (auxDate.getTime() >= diaAtual.getTime()) {
                    proximoDiaSemana = usuarioService.tratarData(auxDate.getTime());
                    setSDiaRotaPrevisaoRota(proximoDiaSemana);
                    auxDate.setHours(21);
                    auxDate.setMinutes(59);
                    auxDate.setSeconds(59);
                    auxDate.setMilliseconds(999);
                    setTimestampPrevisaoRota(auxDate.getTime());
                    break;
                }
            }
            else {
                if (auxDate.getTime() > diaAtual.getTime()) {
                    proximoDiaSemana = usuarioService.tratarData(auxDate.getTime());
                    setSDiaRotaPrevisaoRota(proximoDiaSemana);
                    auxDate.setHours(21);
                    auxDate.setMinutes(59);
                    auxDate.setSeconds(59);
                    auxDate.setMilliseconds(999);
                    setTimestampPrevisaoRota(auxDate.getTime());
                    break;
                }
            }
        }
    }

    function alterarTimestampPrevisaoRota(data) {
        console.log(data)
        let auxDate = new Date(data.substr(0, 4), (data.substr(5, 2) - 1), data.substr(8, 2));

        console.log(auxDate.getTime())
        setSDiaRotaPrevisaoRota(usuarioService.tratarData(auxDate.getTime()));
        auxDate.setHours(21);
        auxDate.setMinutes(59);
        auxDate.setSeconds(59);
        auxDate.setMilliseconds(999);
        setTimestampPrevisaoRota(auxDate.getTime());
    }


    async function getBloquearCompraPagamentoPendente(idCliente) {
        usuarioService.getBloqueiaCompraPagamentoPendente(idCliente).on('value', snapshot => {
            if (snapshot) {
                const dados = snapshot.val();
                setBloquearCompraPagamentoPendente(dados ? dados : false);
            }
        });
    }

    async function verificaPagamentoPendente(idCliente) {
        usuarioService.getPedidos(idCliente).on('value', snapshot => {
            if (snapshot) {
                let dados;
                let bPagamentoPendente = false;
                snapshot.forEach((item) => {
                    dados = item.val();

                    if (dados?.StatusPagamento !== 'Pago' && dados?.StatusPagamento !== 'Cancelado') {
                        bPagamentoPendente = true;

                        if (bPagamentoPendente && !bUsuarioAlertadoPagamentoPendente) {
                            bUsuarioAlertadoPagamentoPendente = true
                            alertarPagamentoPendente(item.key)
                        }
                    }
                });

                setPagamentoPendente(bPagamentoPendente);
            } else
                setPagamentoPendente(false);
        });
    }

    const alertarPagamentoPendente = (idPedido) => {
        setMensagemPagamentoPendente(`O pagamento do pedido ${idPedido} está pendente.`);
        setModal('PagamentoPendente');
    }

    const retornaTotalVoucherGasto = () => {
        if (creditoVoucher - totalCompra >= 0) {
            return ((creditoVoucher - totalCompra) - creditoVoucher) * -1;
        }

        if (creditoVoucher - totalCompra < 0) {
            return creditoVoucher;
        }
    }

    const retornaTotalCompraValidandoVoucher = () => {
        if (creditoVoucher === 0)
            return totalCompra;
        if (totalCompra < creditoVoucher)
            return 0
        else
            return totalCompra - creditoVoucher;
    }

    return (
        <UserContext.Provider value={{
            statusServidor,
            RecuperarSenha,
            loading,
            signed: Boolean(user),
            updateLoading,
            Login,
            SingOut,
            user,
            modal,
            updateModal,
            setSolicitacaoCadastro,
            produtoSelecionado,
            selecionarProduto,
            categoria,
            updateCategoria,
            paginaAtual,
            updatePaginaAtual,
            filtro,
            updateFiltro,
            credito,
            updateCredito,
            carrinho,
            updateItemCarrinho,
            removerItemCarrinho,
            esvaziarCarrinho,
            totalCompra,
            contItens,
            pedidoSelecionado,
            selecionarPedido,
            produtosPedidoSelecionadoViaURL,
            setProdutosPedidoSelecionadoURL,
            valorMinimoBoleto,
            valorMinimoBoletoQuinzeDias,
            valorMinimoDuasParcelas,
            valorMinimoPedido,
            valorMinimoCheque,
            statusVersaoServidor,
            verficaProdutoCarrinho, //Para saber se o produto já está no carrinho e editá-lo
            gruposPromocionais,
            listaProdutosPromocionais,
            grupoPromocionalProdutoSelecionado,
            contarProdutosGrupo,
            contTotalProdutosGrupo,
            validarDescontoGrupoProduto,
            getGrupoPromocionalProduto,
            //Atualiza o carrinho com os itens removidos
            setItensRemovidosFaltaEstoqueCarrinho,
            itensRemovidosFaltaEstoqueCarrinho,
            setIDCompraConfirmadaEstoqueAlterado,
            idCompraConfirmadaEstoqueAlterado,
            setBPentendeCompraAlteradaEstoque,
            bPentendeCompraAlteradaEstoque,
            limparCarrinhoCompraEstoque,
            //Dados da rota
            sDiaRotaPrevisaoRota,
            timestampPrevisaoRota,
            getVerificarRota,
            idRotaEntrega,
            idCidade,
            nomeRota,
            latitude,
            longitude,
            aDatasDisponiveisRota,
            alterarTimestampPrevisaoRota,

            bAtualizarProdutosHome,
            setBAtualizarProdutosHome,


            ip,

            bloquearCompraPagamentoPendente,
            pagamentoPendente,
            creditoVoucher,
            retornaTotalCompraValidandoVoucher,
            retornaTotalVoucherGasto,
            mensagemPagamentoPendente,

            setCarrinho,
            calcularTotalCompra,
            setContItens,
        }}>
            {children}
        </UserContext.Provider >
    );
};

export default UserContext;